import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AffiliateEmailSignInForm from './AffiliateEmailSignInForm';
import AffiliateEmailSignUpForm from './AffiliateEmailSignUpForm';
import AffiliatePasswordRecoveryModal from '../Modal/AffiliatePasswordRecoveryModal';
import SocialButtons from './SocialButtons/SocialButtons';
import SocialButtonsView from './SocialButtons/SocialButtonsView';
import { STATIC_PATH } from '../../config';
import { shouldDisableRecaptcha } from '../../utils/utils';
import { useClientRedirect } from '../../hooks';

const AuthSection = ({ type }) => {
  const [currentForm, setCurrentForm] = useState(type);
  const [signUpState, setSignUpState] = useState(null);
  const [recoveryStatus, setRecoveryStatus] = useState('password_recovery_start');

  useClientRedirect();

  const { isAuthenticated, locale, socials, isRecaptchaLoaded } = useSelector(
    ({ intl: { locale }, webmaster: { isAuthenticated }, app }) => ({
      isAuthenticated,
      locale,
      socials: app.authSettings.socials,
      isRecaptchaLoaded: app.authSettings.isRecaptchaLoaded,
    }),
  );
  const isRecaptchaDisabled = shouldDisableRecaptcha();

  useEffect(() => {
    setCurrentForm(type);
    if (type === 'sign_in' || type === 'sign_up') {
      window.scrollTo({
        top: document.querySelector('.auth-right').offsetTop,
        behavior: 'smooth',
      });
    }
  }, [type]);

  useEffect(() => {
    const pathname = window.location.pathname.replace(/\/$/, '');
    if (pathname === '/recovery') {
      setCurrentForm('recovery');
      setRecoveryStatus('password_recovery_start');
    }
  }, []);

  const handleSignUpStateChange = (state) => {
    setSignUpState(state);
  };

  const renderForm = (_) => {
    switch (currentForm) {
      case 'sign_up':
        return (
          <AffiliateEmailSignUpForm
            locale={locale}
            changeForm={setCurrentForm}
            onStateChange={handleSignUpStateChange}
          />
        );
      case 'sign_in':
        return <AffiliateEmailSignInForm locale={locale} changeForm={setCurrentForm} />;
      case 'recovery':
        return (
          <AffiliatePasswordRecoveryModal
            locale={locale}
            changeForm={setCurrentForm}
            status={recoveryStatus}
            onStatusChange={setRecoveryStatus}
          />
        );
      default:
        return <AffiliateEmailSignInForm locale={locale} changeForm={setCurrentForm} />;
    }
  };

  return (
    <section id="auth" className="auth">
      <div className="auth-right">
        <div className="auth-right-inner">
          {isAuthenticated === 0 || (!isRecaptchaLoaded && !isRecaptchaDisabled) ? (
            <span className="loading-spinner" />
          ) : isAuthenticated > 0 ? null : (
            <div className="card auth-card">
              <NavLink className="auth-logo" to="/publisher/sign_in">
                <img src={`${STATIC_PATH}/img/svg/logo-b.svg`} alt="Affiliate" />
                <span>Партнерская программа</span>
              </NavLink>

              {(!currentForm || currentForm === 'sign_in') && (
                <p className="form-title-main">
                  <FormattedMessage id="affiliate.login" defaultMessage="Sign in" />
                </p>
              )}
              {currentForm === 'sign_up' && signUpState === 'registration' && (
                <p className="form-title-main">
                  <FormattedMessage id="affiliate.register" defaultMessage="Sign up" />
                </p>
              )}
              {currentForm === 'sign_up' && signUpState === 'activate' && (
                <p className="form-title-main form-title-main-almost">
                  <FormattedMessage
                    id="affiliate.register.success"
                    defaultMessage="Почти готово!"
                  />
                </p>
              )}

              <div className="card-body">{renderForm()}</div>
              {(!currentForm || currentForm === 'sign_in') && (
                <div className="card-footer">
                  <div className="alternative-ways-wrapper">
                    {socials ? (
                      <SocialButtons view={SocialButtonsView} socials={socials} />
                    ) : (
                      <span className="socials-loading-spinner loading-spinner" />
                    )}
                  </div>
                </div>
              )}

              {(!currentForm || currentForm === 'sign_in') && (
                <p className="card-bottom-text">
                  <FormattedMessage
                    id="affiliate.auth.link.to_signup.title"
                    defaultMessage="Sign in&nbsp;with"
                  />{' '}
                  <NavLink to="/publisher/sign_up">
                    <FormattedMessage
                      id="affiliate.auth.link.to_signup.button"
                      defaultMessage="Зарегистрироваться"
                    />
                  </NavLink>
                </p>
              )}
              {currentForm === 'sign_up' && signUpState === 'registration' && (
                <p className="card-bottom-text">
                  <FormattedMessage
                    id="affiliate.auth.link.to_signin.title"
                    defaultMessage="Уже есть аккаунт?"
                  />{' '}
                  <NavLink to="/publisher/sign_in">
                    <FormattedMessage
                      id="affiliate.auth.link.to_signin.button"
                      defaultMessage="Войти"
                    />
                  </NavLink>
                </p>
              )}
              {currentForm === 'sign_up' && signUpState === 'activate' && (
                <p className="card-bottom-text">
                  <FormattedMessage id="affiliate.auth.wrong-email" defaultMessage="Sign In" />{' '}
                  <NavLink to="/publisher/sign_up">
                    <FormattedMessage id="affiliate.auth.retry-email" defaultMessage="Sign In" />
                  </NavLink>
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default AuthSection;
